import { render, staticRenderFns } from "./ImpersonateLandingView.vue?vue&type=template&id=36619882&scoped=true"
import script from "./ImpersonateLandingView.vue?vue&type=script&lang=js"
export * from "./ImpersonateLandingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36619882",
  null
  
)

export default component.exports